import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
    Legend,
    Tooltip
} from 'recharts';

interface RadarData {
    subject: string;
    [key: string]: string | number;
}

interface RadarCompareChartProps {
    data: RadarData[];
    subjects: {
        key: string;
        name: string;
        color: string;
    }[];
}

export default function RadarCompareChart({ data, subjects }: RadarCompareChartProps) {
    return (
        <div className="h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                    <PolarGrid stroke="#374151" />
                    <PolarAngleAxis
                        dataKey="subject"
                        tick={{ fill: '#9CA3AF', fontSize: 12 }}
                    />
                    <PolarRadiusAxis
                        angle={30}
                        domain={[0, 10]}
                        tick={{ fill: '#4B5563' }}
                        axisLine={false}
                        tickCount={6}
                    />

                    {subjects.map((subject) => (
                        <Radar
                            key={subject.key}
                            name={subject.name}
                            dataKey={subject.key}
                            stroke={subject.color}
                            fill={subject.color}
                            fillOpacity={0.3}
                        />
                    ))}

                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#1F2937',
                            border: '1px solid #374151',
                            borderRadius: '8px'
                        }}
                        itemStyle={{ color: '#F3F4F6' }}
                    />
                    <Legend wrapperStyle={{ paddingTop: '20px' }} />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
}
